import { render, staticRenderFns } from "./prtoducts-table-skeleton.vue?vue&type=template&id=79a15d5d&"
import script from "./prtoducts-table-skeleton.vue?vue&type=script&lang=js&"
export * from "./prtoducts-table-skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports